var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.DokuWikiWrapper,_vm._g(_vm._b({attrs:{"wiki-page":_setup.routeWikiPage,"query":_setup.routeQuery}},'DokuWikiWrapper',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }